// ref-link-strip — inline row of KB/KG LinkIcons for agent event expanded body.
// Only renders when refs present — callers never show this component with empty data.

import { useTranslations } from "use-intl";
import { useNavigate } from "@tanstack/react-router";
import { LinkIcon } from "@/components/ui/link-icon/link-icon";
import type { KbRef, KgRef } from "@/types/workflow.types";

interface RefLinkStripProps {
  kbRefs?: KbRef[];
  kgRefs?: KgRef[];
}

export function RefLinkStrip({ kbRefs, kgRefs }: RefLinkStripProps) {
  const t = useTranslations("workflows");
  const navigate = useNavigate();

  if (!kbRefs?.length && !kgRefs?.length) return null;

  return (
    <div className="flex items-center gap-1.5 mt-2 flex-wrap">
      {kbRefs?.map((ref) => (
        <LinkIcon
          key={ref.id}
          variant="kb"
          title={t("run.kb_link", { count: ref.count ?? 0 })}
          onClick={() => navigate({ to: "/knowledges/$knowledgeId", params: { knowledgeId: ref.id } })}
        />
      ))}
      {kgRefs?.map((ref) => (
        <LinkIcon
          key={ref.id}
          variant="kg"
          title={t("run.kg_link", { entities: ref.entityCount ?? 0, relations: ref.relationCount ?? 0 })}
          onClick={() => navigate({ to: "/kg-graph", search: { focus: ref.id } })}
        />
      ))}
    </div>
  );
}
